/**
 * API service for Nastavení → Sklizeň OAI (CZNA-1562).
 *
 * Consumes the two admin endpoints of mod-czna-authorities' `OaiHarvestController`,
 * both behind `czna-authorities.oai.harvest.get`. They live under `/oai`, beside the
 * public OAI-PMH endpoint, not under `/czna-authorities`. Types mirror the backend
 * `HarvestStatistics`, `HarvestLogPage` and `HarvestLogEntry`.
 */
import { getHeaders } from './apiUtils';
import { API_PATHS } from '../types/apiPaths';
/** Rows per "Načíst další"; the controller accepts 1..500. */
export var HARVEST_LOG_PAGE_SIZE = 50;
/** Statistics of the requests since `since` (ISO instant). */
export var fetchHarvestStatistics = function (ky, since) { return (ky.get(API_PATHS.OAI_HARVEST_STATISTICS, {
    headers: getHeaders(),
    searchParams: { since: since },
}).json()); };
/** One page of the request log. */
export var fetchHarvestLog = function (ky, query) {
    var _a;
    var searchParams = {
        from: query.from,
        limit: String(HARVEST_LOG_PAGE_SIZE),
    };
    if (query.status)
        searchParams.status = query.status;
    var clientIp = (_a = query.clientIp) === null || _a === void 0 ? void 0 : _a.trim();
    if (clientIp)
        searchParams.clientIp = clientIp;
    if (query.cursor)
        searchParams.cursor = query.cursor;
    return ky.get(API_PATHS.OAI_HARVEST_LOG, {
        headers: getHeaders(),
        searchParams: searchParams,
    }).json();
};
